import './index.scss';
import React, {PropTypes} from 'react';
import Accordion from '../../../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import LocationsTable from './locations-table';
import SelectedPostingDate from '../../../state/selected-posting-date';
import {buildNumber} from '../../../../../shared/services/build-number';

const LocationsAccordion = props =>
    <Accordion
        accordionId='locations-accordion'
        body={
            <LocationsTable
                leadAccount={props.selectedLeadAccount.leadAccount.account}
                leadAccountName={props.selectedLeadAccount.leadAccount.name}
                locations={props.locations}
                selectedPostingDate={props.selectedPostingDate}
            />
        }
        title={
            <FormattedMessage
                id='LOCATIONS_WITH_COUNT'
                values={{
                    count: buildNumber(props.locations.length)
                }}
            />
        }
    />;

LocationsAccordion.displayName = 'LocationsAccordion';
LocationsAccordion.propTypes = {
    locations: PropTypes.array.isRequired,
    selectedLeadAccount: PropTypes.object.isRequired,
    selectedPostingDate: PropTypes.instanceOf(SelectedPostingDate)
};

export default LocationsAccordion;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/reimbursement-summary-main/locations-accordion/index.js